import React from 'react'
import Logs from './Logs';
import CashReceiptDetail from './CashReceiptDetail';

const ViewCashReceiptDetail = ({ data }) => {
    const { details, setDetails, logs, loading, setLoading, paginationInfo, dropdowns, onViewSlip, cashReceiptId, setPaginationInfo } = data;

    const cashReceiptDetailProps = {
        dropdowns,
        details: details?.details,
        setDetails,
        loading,
        setLoading,
        paginationInfo,
        setPaginationInfo,
        onViewSlip,
        cashReceiptId
    };

    return (
        <>
            <CashReceiptDetail data={cashReceiptDetailProps} />
            <Logs rows={logs?.depositSlipDetailsAuditDTOList} />
        </>
    );
}

export default ViewCashReceiptDetail;